<template>
    <video ref="videoPlayer" class="video-js"></video>
</template>

<script>
import videojs from "video.js"
import "video.js/dist/video-js.css"

export default {
    mounted() {
        this.player = videojs(this.$refs.videoPlayer, this.playerOptions, function onPlayerReady() {
            console.log("onPlayerReady", this)
        })
    },

    props: {
        options: {
            type: Object,
        },
    },

    computed: {
        playerOptions() {
            return _.defaultsDeep(this.options, {
                autoplay: false,
                controls: true,
                controlBar: {
                    playToggle: true,
                    volumePanel: true,
                    fullscreenToggle: true,
                    liveDisplay: false,
                },
                preload: "auto",
                fluid: true,
                disablePictureInPicture: true,
                responsive: true,
                experimentalSvgIcons: true,
                // playbackRates: [0.5, 1, 1.5, 2],
                html5: true,
                sources: [
                    {
                        type: "application/x-mpegURL",
                    },
                ],
            })
        },
    },

    data() {
        return {
            player: null,
        }
    },

    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },
}
</script>
